define('lq/ajax',[
    'jquery'
], function($) {

    // for now we retry all non-successful requests that are not in this list
    // an alternative approach is to retry only requests for which jqXHR.status === 0 (so for which we did not receive a response from the server)
    const ignoredStatuses= [500,401];

    // why the server refused a request. reason_of_failing is the old name of the header: some proxies and firewalls
    // drop headers with underscores, so the server sends both (see ValidateJsonAntiForgeryTokenAttribute)
    const failureReason = function(jqXHR) {
        if (!jqXHR || !jqXHR.getResponseHeader)
            return null;
        return jqXHR.getResponseHeader('X-Failure-Reason') || jqXHR.getResponseHeader('reason_of_failing');
    };

    // the server rejects a request with a missing/stale anti-forgery token before running it,
    // so retrying it unchanged can never succeed (see ValidateJsonAntiForgeryTokenAttribute)
    const isAntiforgeryRejection = function(jqXHR) {
        return jqXHR.status === 400 && failureReason(jqXHR) === 'antiforgery_token_invalid';
    };

    const withRetry = function(options, retries = 3, delay = 200) {
        options = options || {};

        return $.Deferred(function (deferred) {
            var antiforgeryRecoveryUsed = false;

            function attempt(remainingRetries, currentDelay) {
                // global: false => we are going to trigger the global ajaxError-event manually (and only after the last failed try)
                const ajaxOptions = $.extend({}, options, { global: false });

                // jQuery calls the error option for every failed attempt. A rejection that is about to be
                // recovered is not an error for the caller, so keep it away from the error callback.
                if (options.recoverFromAntiforgeryRejection && !antiforgeryRecoveryUsed && $.isFunction(options.error)) {
                    ajaxOptions.error = function (jqXHR) {
                        if (!isAntiforgeryRejection(jqXHR))
                            return options.error.apply(this, arguments);
                    };
                }

                var xhr = $.ajax(ajaxOptions)
                    .done(function (data, textStatus, jqXHR) {
                        deferred.resolve(data, textStatus, jqXHR);
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        var giveUp = function () {
                            $(document).trigger('ajaxError', [jqXHR, options, errorThrown]);
                            deferred.reject(jqXHR, textStatus, errorThrown);
                        };

                        if (isAntiforgeryRejection(jqXHR) && options.recoverFromAntiforgeryRejection && !antiforgeryRecoveryUsed) {
                            // the request was not executed, so it is safe to replay once with a fresh token.
                            // this does not count as a retry and the first rejection is not reported as an error.
                            antiforgeryRecoveryUsed = true;
                            options.recoverFromAntiforgeryRejection(function () {
                                attempt(remainingRetries, currentDelay);
                            }, function () {
                                // the error callback skipped this rejection, so deliver it now that it stays an error
                                if ($.isFunction(options.error))
                                    options.error(jqXHR, textStatus, errorThrown);
                                giveUp();
                            }, jqXHR);
                        } else if (ignoredStatuses.indexOf(jqXHR.status) !== -1 || isAntiforgeryRejection(jqXHR) || jqXHR.statusText === 'abort') {
                            giveUp();
                        } else if (remainingRetries > 0) {
                            setTimeout(function () {
                                attempt(remainingRetries - 1, currentDelay * 2);
                            }, currentDelay);
                        } else {
                            giveUp();
                        }
                    });

                if (options.signal) {
                    if (options.signal.aborted) {
                        xhr.abort();
                    } else {
                        var abortRequest = ()=> xhr.abort();

                        options.signal.addEventListener("abort", abortRequest);

                        xhr.always(function() {
                            options.signal.removeEventListener("abort", abortRequest);
                        });                        
                    }                    
                }
            }

            attempt(retries, delay);
        }).promise();
    };

    return {
        withRetry: withRetry,
        failureReason: failureReason
    };
});

